import {
  DEFAULT_HEALTH_FACILITY_FEATURE_CONFIG,
  HealthCareFacilityModel,
} from "../../../data-model/healthFacility";

export const checkBoxSelectedByDefault = {
  authReview: false,
  coverageCheck: false,
  medicalNeccessityChecklist: false,
  paSubmission: false,
  pharmaPa: false,
};

export const initialFacilityData: HealthCareFacilityModel = {
  client_id: "",
  Name: "",
  NPI: "",
  TaxID: "",
  PhoneNumber: "",
  FhirId: "",
  is_external_organization: false,

  Address: {
    StreetAddress: "",
    City: "",
    State: "",
    ZIP: "",
  },
  emr_name: "",
  fhir_client: "",
  RisaFaxNumber: "",
  RisaPhoneNumber: "",
  updated_at: "",
  updated_by: "",
  onco_emr_base_url: "",
  inactive_insurance_bo_status: "",
  auth_letter_type: "",
  feature_config: { ...DEFAULT_HEALTH_FACILITY_FEATURE_CONFIG },
  analytics_url: "",
  auth_status_filter: [],
  corresponding_internal_org_id: "",
};
